<template>
  <div class="wanwu">
    <TabBar_m />
    <div class="banner"></div>
    <div class="wanwu_box">
      <div class="title">
        <h6>
          Application fields of the
          <br />ALL CONTENT COUPLET system
        </h6>
        <i></i>
        <h3>
          万物物联系统
          <br />已经应用领域
        </h3>
      </div>
      <div class="wanwu_item_box">
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_1.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧农业</h3>
            <p>通过传感器所传输的数据，可以随时随地掌握作物的信息，对农作物进行远程管理，同时请专家或通过专家系统对作物的病虫害、长势等进行科学诊断与决策。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_2.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧城市</h3>
            <p>充分运用信息和通信技术手段感测、分析、整合城市运行核心系统的各项关键信息，从而对于包括民生、环保、公共安全、城市服务、工商业活动在内的各种需求做出智能的响应。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_3.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧交通</h3>
            <p>以现有交通信息网络、城市道路交通信息系统和各地市交通监控中心的信息资源为基础，加强对城市主干路网交通信息和营运车辆的动态信息采集、汇总、融合。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_4.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧金融</h3>
            <p>通过打通线上线下的各类数据，将虚拟经济和实体经济连接，从信息对冲中探索新的盈利模式和商业运营模式。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_5.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧酒店</h3>
            <p>通过监控平台与酒店系统的接口，为客人提供舒适的客房环境，在不泄漏用户隐私的同时，带给用户舒适体验。客人还可以利用无线协议转换器控制红外遥控器设备(如：电视、空调、电动窗帘等)。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_6.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧养殖</h3>
            <p>通过传感器在线采集养殖场环境信息（二氧化碳、氨气、硫化氢、空气温湿度等），养殖户可以通过手机、电脑等信息终端，实时掌握养殖场环境信息，及时获取异常报警信息。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_7.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧出行</h3>
            <p>透过感测装置捕捉车辆、驾驶、乘客、及周围环境的相关信息，不断优化对话接口，调整驾驶状态，提高出行效率。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_8.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧仓储</h3>
            <p>智慧仓储的应用，保证了货物仓库管理各个环节数据输入的速度和准确性。方便企业及时掌握所有库存货物当前所在位置，有利于提高仓库管理的工作效率。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_9.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧物流</h3>
            <p>智慧物流是一种以信息技术为支撑，在物流的运输、仓储、包装、装卸搬运、流通加工、配送、信息服务等各个环节实现系统感知，最大限度降低企业成本。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_10.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧电力</h3>
            <p>将万物物联应用在电力传输的各个环节，在大客户配变监控等领域下，自动化计量系统开始启动，使得电力故障可以及时快速响应解决。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_11.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧家居</h3>
            <p>将万物物联应用于家居系统，实现随时随地控制家里的智能设备，比如远程开启家中的电饭煲、空调、空气净化器、电热水器，纵享智慧家居生活。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_12.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧医疗</h3>
            <p>通过传感器与移动设备来对生物的生理状态进行捕捉。如心跳频率、体力消耗、葡萄糖摄取、血压高低等生命指数。把它们记录到电子健康文件里面。方便个人或医生进行查阅。</p>
          </div>
        </div>
        <div class="wanwu_item">
          <div class="wanwu_img">
            <img src="../assets/image_m/wanwu_13.png" alt />
          </div>
          <div class="wanwu_txt">
            <h3>智慧学校</h3>
            <p>化的校园工作、学习和生活一体化环境，这个一体化环境以各种应用服务系统为载体，将教学、科研、管理和校园生活进行充分融合。</p>
          </div>
        </div>
      </div>

      <div class="application">
        <div class="title">
          <h6>Application scenarios</h6>
          <i></i>
          <h3>应用场景</h3>
        </div>

        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/wanwu_14.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>智能汽车应用</h3>
              <p>塞车找不到停车位？不用紧张，在物联网时代，透过智能汽车连结云端，不但能教你抄快捷方式，还会告诉您哪里有车位。</p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/wanwu_15.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>智能家居应用</h3>
              <p>下班好累，回家只想休息？没问题，智能电饭锅里面有着依据个人口感喜好、才刚煮好的米饭，简单炒个青菜，晚餐就能搞定了。</p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/wanwu_16.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>智慧抄表应用</h3>
              <p>塞车找不到停车位？不用紧张，在物联网时代，透过智能汽车连结云端，不但能教你抄快捷方式，还会告诉您哪里有车位。</p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/wanwu_17.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>智慧洗手间</h3>
              <p>利用传感器和无线传输技术，让厕纸、洗手液等消耗品成为物联网中的一员。当物品耗尽时，传感器可以及时感应并通过网络向服务器发出通知。完美解决厕所纸用光后不能及时补充的问题。</p>
            </div>
          </swiper-slide>
          <swiper-slide class="item">
            <div class="swiper_img">
              <img src="../assets/image_m/wanwu_18.png" alt />
            </div>
            <div class="swiper_item_txt">
              <h3>智能路灯应用</h3>
              <p>通过远程调节灯光，更好地配合当时环境调节，达到节约能源的目的。例如在月夜调暗灯光，遇到暴雨或大雾天再把灯光调亮。</p>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <Footer_m />
  </div>
</template>

<script>
export default {
  name: "Wanwu",
  components: {},
  props: {},
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
        },
        slidesPerView: 1.6,
        centeredSlides: true,
        loop: true,
        // Some Swiper option/callback...
      },
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.banner {
  background: url("../assets/image_m/wanwu_bgc.png") no-repeat;
  background-position: center;
  background-size: 100%;
  margin-top: 50px;
  &::after {
    padding-top: 100%;
    content: "";
    display: block;
  }
}
.wanwu_box {
  .title {
    padding: 16px;
    h6 {
      line-height: 15px;
      font-size: 10px;
      text-transform: uppercase;
    }
    i {
      display: block;
      width: 30px;
      height: 2px;
      background: #26acff;
      margin: 4px 0;
    }
    h3 {
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 12px;
    }
    p {
      text-indent: 2em;
      line-height: 21px;
      font-size: 15px;
    }
  }
  .wanwu_item_box {
    padding: 0 16px;
    .wanwu_item {
      display: flex;
      margin-bottom: 24px;
      .wanwu_img {
        width: 100px;
        height: 87px;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }
      .wanwu_txt {
        margin-left: 12px;
        h3 {
          line-height: 13px;
          font-size: 15px;
          margin-bottom: 4px;
        }
        p {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }
}
//轮播图样式
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  // -webkit-box-pack: center;
  // -ms-flex-pack: center;
  // -webkit-justify-content: center;
  // justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.item {
  //width: 231px !important;
  // height: 298px;
  border: 1px solid #eaeaea;
  // background-color: aqua;
  //margin-right: 0 !important;
  .swiper_img {
    img {
      width: 100%;
    }
  }
  .swiper_item_txt {
    padding: 12px 12px 30px 12px;
    h3 {
      line-height: 12px;
      font-size: 14px;
      margin-bottom: 4px;
    }
    p {
      line-height: 18px;
      font-size: 12px;
    }
  }
}
</style>